<template>
  <div :class="{ 'navigation-menu-item--extra-margin': !title }" class="navigation-menu-item">
    <div class="navigation-menu-item__heading">
      <h2 v-if="title" class="navigation-menu-item__title">
        {{ title }}
      </h2>
      <img
        v-if="iconSource"
        class="navigation-menu-item__icon"
        :src="iconSource"
        alt="icon-menu-item"
        role="button"
        tabindex="0"
        @click="$emit('onIconClick')"
        @keydown.enter="$emit('onIconClick')"
        @keydown.space="(event) => handleSpaceKey(event, 'onIconClick')"
      />
      <img
        v-if="closeable"
        :src="crossSource"
        alt="icon-close"
        class="navigation-menu-item__cross"
        role="button"
        tabindex="0"
        @click="$emit('close')"
        @keydown.enter="$emit('close')"
        @keydown.space="(event) => handleSpaceKey(event, 'close')"
      />
    </div>
    <slot />
  </div>
</template>

/** A component for every entity in the navigation menu **/
<script>
export default {
  name: 'NavigationMenuItem',
  props: {
    title: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: false
    },
    iconSource: {
      type: String,
      default: ''
    }
  },
  emits: ['onIconClick', 'close'],
  data() {
    return {
      crossSource: require('../../../assets/icon-cross--white.svg')
    }
  },
  methods: {
    handleSpaceKey(event, emitName) {
      event.preventDefault()
      this.$emit(emitName)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

.navigation-menu-item {
  margin-bottom: $margin-drop-down-item;
  &--extra-margin {
    margin-top: $margin-small;
  }
  &__heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    color: $color-text-white;
  }
  &__icon {
    height: 24px;
    cursor: pointer;
  }
  &__cross {
    transform: rotate(45deg);
  }
}
</style>
